import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Favoriteprovider } from '../../providers/favoriteprovider';
import { FirebaseListObservable } from "angularfire2";

import { ProductPage } from "../product/product";


/**
 * Generated class for the Favorites page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-favorites',
  templateUrl: 'favorites.html',
})
export class FavoritesPage {
    
    public favoriteItems = [];

constructor(public navCtrl: NavController, public favoriteProvider: Favoriteprovider) {

}
    
openProduct(item: FirebaseListObservable<any>) {
        this.navCtrl.push(ProductPage, {
            item: item
        });
}
    
reorderItems(indexes) {
    let element = this.favoriteItems[indexes.from];
    this.favoriteItems.splice(indexes.from, 1);
    this.favoriteItems.splice(indexes.to, 0, element);
    
    this.favoriteProvider.save(this.favoriteItems);
}
    
showReorder(): boolean {
    if(this.favoriteItems.length>1){return true;}
    else{return false;}
}
    
unfavoriteItem(favorite){
    let index = this.favoriteItems.indexOf(favorite);

    if(index > -1){
      this.favoriteItems.splice(index, 1);
    }

    this.favoriteProvider.save(this.favoriteItems);
}
    
reloadFavorites(){
    this.favoriteProvider.getFavorites().then((favorites) => {
 
      if(favorites){
        this.favoriteItems = JSON.parse(favorites); 
      }
 
    }); 
}
    
ionViewWillEnter(){
    this.reloadFavorites();
}
    
}



// WEBPACK FOOTER //
// ./src/pages/favorites/favorites.ts